import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AccountStateService } from '../../../services/account-state.service';

@Component({
  selector: 'sub-navigation',
  imports: [MatButtonModule],
  templateUrl: './sub-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sub-navigation.component.scss',
})
export class SubNavigationComponent {
  private _accountStateService = inject(AccountStateService);

  public isAdministrator = computed(() => this._accountStateService.$account()?.administrator);
  public userUid = computed(() => this._accountStateService.$account()?.uid);
}
